// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M7 20l4-16m2 16l4-16M6 9h14M4 15h14\"/> </svg> ";
// Exports
module.exports = code;